// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
    ImageList
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect  } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import SingleImageDialog from './SingleImageDialog';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const RejectKYCModal = ({
    rejectKYCModalOpen,
    setRejectKYCModalOpen,
    row,
    fetchKYCRecords,
    rejectReasons
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [rejectReason, setRejectReason] = useState('');
    
    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateKYC = async () => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/KYCVerification/Reject',
                {
                    id: row ? row.id : 0,
                    customerID: row ? row.customerID : 0,
                    rejectReasonID: rejectReason ? parseInt(rejectReason) : 0
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('成功批准充值');
                fetchKYCRecords();
                setRejectKYCModalOpen(false);
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    return (
        <>
            <Modal
                open={rejectKYCModalOpen}
                onClose={() => setRejectKYCModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 'bolder' }}>
                        {t("customer.kycVerification")}
                    </Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='kycVerificationTypeNameTitle' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.kycVerificationType")} : 
                            </Box>
                        </Grid>
                        <Grid key='kycVerificationTypeName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="kycVerificationTypeName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={row ? row.typeName : ''}
                                disabled={true}
                                style={{backgroundColor: 'grey'}}
                            />
                        </Grid>
                    </Grid>
                    {/* <Grid item container pr={{ md: '5px' }}>
                        <Grid key='fullNameTitle' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.fullName")} : 
                            </Box>
                        </Grid>
                        <Grid key='fullName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="fullName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={row ? row.fullName : ''}
                                disabled={true}
                                style={{backgroundColor: 'grey'}}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='idNumberTitle' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.idNumber")} : 
                            </Box>
                        </Grid>
                        <Grid key='idNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="idNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={row ? row.idNumber : ''}
                                disabled={true}
                                style={{backgroundColor: 'grey'}}
                            />
                        </Grid>
                    </Grid> */}
                    <Grid item container pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {row?.imageUrl?.length > 0 && (
                                <ImageList sx={{ width: '100%' }} cols={3} rowHeight={'auto'}>
                                    {row?.imageUrl?.map((item, index) => (
                                        <SingleImageDialog imageSrc={item} key={index} />
                                    ))}
                                </ImageList>
                            )}
                        </Box>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='rejectReasonTitle' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.rejectReason")} : 
                            </Box>
                        </Grid>
                        <Grid key='rejectReason' xs={7} sx={{ mt: 2 }}>
                            <Select
                                displayEmpty
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                            >
                                <MenuItem sx={{ width: '100%' }} value="">
                                    {t("customer.selectRejectReason")}
                                </MenuItem>
                                {rejectReasons.map((item, index) => (
                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                    <Box style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: 'red',
                                marginTop: '30px'
                            }}
                            onClick={submitUpdateKYC}
                            disabled={updateButtonDisabled}
                        >
                            {t("withdrawal.reject")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: 'grey',
                                marginTop: '30px',
                                marginLeft: '30px'
                            }}
                            onClick={() => setRejectKYCModalOpen(false)}
                            disabled={updateButtonDisabled}
                        >
                            {t("withdrawal.cancel")}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default RejectKYCModal;